import { LAYOUTS, } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { goBackAction, onChangeAction, validateOtp } from "./actions";
import { StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { getStatementCtaAction, onChangeDimension } from "../cgtcInit/actions";
import sharedPropsService from "../../SharedPropsService";
export const template = (height, phone, pan, fromDate, toDate, leadId) => ({
    layout: {
        id: ROUTE.CGTC_OTP,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            { id: 'cgtcOtpRootContainer', type: WIDGET.STACK },
        ],
    },
    datastore: {
        cgtcOtpRootContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'cgtcOtpPage', type: WIDGET.CGTC_OTP }
            ],
            dimensionAction: {
                type: ACTION.ON_CHANGE_DIMENSION,
                routeId: ROUTE.CGTC_OTP,
                payload: {}
            }
        },
        cgtcOtpPage: {
            show: true,
            phoneNumber: phone,
            onChangeAction: {
                type: ACTION.ON_CHANGE,
                routeId: ROUTE.CGTC_OTP,
                payload: {}
            },
            editAction: {
                type: ACTION.EDIT,
                routeId: ROUTE.CGTC_OTP,
                payload: {}
            },
            resendAction: {
                type: ACTION.RESEND_OTP,
                routeId: ROUTE.CGTC_OTP,
                payload: {
                    leadId: leadId,
                    phone: phone,
                    pan: pan,
                    fromDate: fromDate,
                    toDate: toDate,
                    isResend: true
                }
            },
            verifyAction: {
                type: ACTION.TRIGGER_OTP_VALIDATION,
                routeId: ROUTE.CGTC_OTP,
                payload: {}
            }
        }
    },
});
export const cgtcOtpMF = {
    onLoad: async ({ getHeight, network, navigateToBase, setDatastore, ...props }) => {
        const cgstUserContext = await sharedPropsService.getCgtcUserContext();
        const phone = cgstUserContext?.phone;
        const pan = cgstUserContext?.pan;
        const fromDate = cgstUserContext?.fromDate;
        const toDate = cgstUserContext?.toDate;
        const leadId = cgstUserContext?.leadId;
        return Promise.resolve(template(getHeight(), phone, pan, fromDate, toDate, leadId));
    },
    actions: {
        [ACTION.EDIT]: goBackAction,
        [ACTION.ON_CHANGE_DIMENSION]: onChangeDimension,
        [ACTION.TRIGGER_OTP_VALIDATION]: validateOtp,
        [ACTION.ON_CHANGE]: onChangeAction,
        [ACTION.RESEND_OTP]: getStatementCtaAction
    },
    clearPrevious: true,
};
